import script from "./CashDepositPriceTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CashDepositPriceTooltip.vue?vue&type=script&setup=true&lang=js"

import "./CashDepositPriceTooltip.vue?vue&type=style&index=0&id=5256d2d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5256d2d6"]])

export default __exports__